var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7656 0.693817C32.8938 -0.0468083 34.4731 -0.215557 35.815 0.281318C37.1569 0.778194 38 1.83757 38 3.00007L38 33.0001C38 34.1626 37.145 35.2219 35.815 35.7188C34.485 36.2157 32.9056 36.0563 31.7656 35.3063L8.96563 20.3063L7.6 19.4063L7.6 33.0001C7.6 34.6594 5.90187 36.0001 3.8 36.0001C1.69812 36.0001 1.17601e-07 34.6594 2.62668e-07 33.0001L2.88535e-06 3.00007C3.03042e-06 1.34069 1.69813 6.54909e-05 3.8 6.56747e-05C5.90188 6.58584e-05 7.6 1.34069 7.6 3.00007L7.6 16.5938L8.96563 15.6938L31.7656 0.693817Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.2c63940ed4196d075aef2d47ede34067.svg";
export { ForwardRef as ReactComponent };